var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 112,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 112,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC3059",
    d: "M14.183 28h2.938l-3.978-10.088L17.121 9.8h-2.86l-3.692 7.878h-.052V9.8h-2.86V28h2.86v-5.59l.884-1.664L14.183 28ZM12.057 36.667l5.276 7.295-5.39 7.371-5.276-7.295 5.39-7.371ZM40.085 45 48 55.943 39.915 67 32 56.057 40.085 45ZM65.817 84h-2.938l3.978 10.088-3.978 8.112h2.86l3.692-7.878h.052v7.878h2.86V84h-2.86v5.59l-.884 1.664L65.817 84ZM67.943 75.333l-5.276-7.295 5.39-7.371 5.276 7.295-5.39 7.371Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKd);
export default __webpack_public_path__ + "static/media/KD.47c8326942ae3f21f00e58de4a4d6c00.svg";
export { ForwardRef as ReactComponent };